(function () {
    // Check if the module exists before doing anything
    const cardMeetingExists = !!document.querySelector('.card-meeting');

    // If the module exists, do whatever we need to
    if (cardMeetingExists) {
        // Your code here
        console.log('Card meeting JS');
    }
})();
